'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Properties = require('../Properties.js');

var _Properties2 = _interopRequireDefault(_Properties);

var _ChargeV = require('./ChargeV2.js');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conditionValues = {
    deliveryType: ['delivery', 'takeout'],
    platform: ['web', 'mobileweb', 'ios', 'android', 'callcenter', 'com.messenger', 'org.telegram', 'com.slack']
};

var conditionIndexes = {
    enabled: 0,
    deliveryType: 1,
    platform: 2,
    availability: 3
};

var self = {};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.defaultDeliveryTypesCondition = function () {
    return { delivery: true, takeout: true };
};
self.defaultPlatformsCondition = function () {
    return { web: true, mobileweb: true };
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.simplifyCondition = function (condition) {
    var ret = { deliveryTypes: {}, platforms: {}, availability: null, disabled: false };

    // Everything ought to be checked by default
    _lodash2.default.each(conditionValues.deliveryType, function (deliveryType) {
        return ret.deliveryTypes[deliveryType] = true;
    });
    _lodash2.default.each(conditionValues.platform, function (platform) {
        return ret.platforms[platform] = true;
    });

    // Gotta protect from unexpectedly illegal input, so try/catch
    try {
        if (condition.conditions[conditionIndexes.deliveryType].conditions) {
            _lodash2.default.each(condition.conditions[conditionIndexes.deliveryType].conditions, function (subcondition) {
                delete ret.deliveryTypes[subcondition.condition.deliveryType];
            });
        }

        if (condition.conditions[conditionIndexes.platform].conditions) {
            _lodash2.default.each(condition.conditions[conditionIndexes.platform].conditions, function (subcondition) {
                delete ret.platforms[subcondition.condition.platform];
            });
        }

        if (!_lodash2.default.isEmpty(condition.conditions[conditionIndexes.availability].availability)) {
            ret.availability = condition.conditions[conditionIndexes.availability].availability;
        } else {
            ret.availability = null;
        }

        // Find if this is a sold out item, which is marked by a specific availability exception
        var exceptions = (ret.availability || {}).exceptions;
        if (_lodash2.default.find(exceptions, { reason: 'soldout' })) {
            ret.isSoldOut = true;
            ret.availability.exceptions = _lodash2.default.reject(ret.availability.exceptions, { reason: 'soldout' });
        }

        ret.disabled = condition.conditions[conditionIndexes.enabled].type == 'false';
    } catch (e) {
        //console.log('Error in simplifyCondition', e)
    }

    return ret;
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.complicateCondition = function (condition) {
    var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // The ignore parameter is a map that can contain {deliveryType: true, platform: true, availability: true}
    // Each field specified in ignore will be set as simply {type: 'true'}

    if (!condition) {
        return null;
    }

    condition = _lodash2.default.cloneDeep(condition);
    // We don't currently want to support things that are available on IOS but no on Android (or vice versa), so a little hack to prevent it:
    if (condition.platforms) {
        condition.platforms.android = condition.platforms.ios;
    }

    var ret = {
        type: 'and',
        conditions: [{ type: 'true' }, { type: 'true' }, { type: 'true' }, { type: 'true' }]
    };

    if (!ignore.deliveryType) {
        ret.conditions[conditionIndexes.deliveryType] = { type: 'and', conditions: [] };
        _lodash2.default.each(conditionValues.deliveryType, function (deliveryType) {
            if (condition.deliveryTypes && !condition.deliveryTypes[deliveryType]) {
                ret.conditions[conditionIndexes.deliveryType].conditions.push({ type: 'not', condition: { type: 'order_delivery_type', deliveryType: deliveryType } });
            }
        });
    }

    if (!ignore.platform) {
        ret.conditions[conditionIndexes.platform] = { type: 'and', conditions: [] };

        // Platform hack: we don't wish to support a condition with all platforms disabled
        if (_lodash2.default.filter(condition.platforms).length > 0) {
            _lodash2.default.each(conditionValues.platform, function (platform) {
                if (condition.platforms && !condition.platforms[platform]) {
                    ret.conditions[conditionIndexes.platform].conditions.push({ type: 'not', condition: { type: 'order_platform', platform: platform } });
                }
            });
        }
    }

    if (!ignore.availability) {
        ret.conditions[conditionIndexes.availability] = { type: 'order_delivery_time', availability: {} };
        ret.conditions[conditionIndexes.availability].availability = condition.availability || {};
        if (condition.isSoldOut) {
            ret.conditions[conditionIndexes.availability].availability = ret.conditions[conditionIndexes.availability].availability || {};
            ret.conditions[conditionIndexes.availability].availability.exceptions = ret.conditions[conditionIndexes.availability].availability.exceptions || [];
            ret.conditions[conditionIndexes.availability].availability.exceptions.push({ reason: 'soldout', available: false });
        }
    }

    if (condition.disabled) {
        ret.conditions[conditionIndexes.enabled].type = 'false';
    }

    return ret;
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

exports.default = self;